module.exports = __webpack_public_path__ + "static/media/info.f1838a50.svg";